(function () {
  'use strict';

  if (window.__emHalloweenVariantPriceV2) return;
  window.__emHalloweenVariantPriceV2 = true;

  var tracked = new WeakSet();
  var pending = Object.create(null);

  function getSelectedVariant(picker) {
    if (!picker) return null;
    var json = picker.querySelector('script[type="application/json"]');
    if (!json) return null;
    var variants;
    try {
      variants = JSON.parse(json.textContent);
    } catch (error) {
      return null;
    }
    if (!Array.isArray(variants)) return null;
    var groups = Array.prototype.filter.call(picker.children, function (child) {
      return child.classList && child.classList.contains('product-form__input');
    });
    var values = groups.map(function (group) {
      var select = group.querySelector('select');
      if (select) return select.value;
      var input = group.querySelector('input[type="radio"]:checked');
      return input ? input.value : null;
    });
    if (!values.length || values.some(function (value) { return value == null; })) return null;
    return variants.find(function (variant) {
      return Array.isArray(variant.options) &&
        variant.options.length === values.length &&
        variant.options.every(function (value, index) { return value === values[index]; });
    }) || null;
  }

  function setText(root, selector, value) {
    var node = root.querySelector(selector);
    if (node && node.textContent !== String(value)) node.textContent = String(value);
  }

  function apply(sectionId) {
    var picker = document.getElementById('variant-selects-' + sectionId);
    var priceBlock = document.getElementById('price-' + sectionId);
    var priceData = document.getElementById('em-variant-prices-' + sectionId);
    if (!picker || !priceBlock || !priceData) return;
    var variant = getSelectedVariant(picker);
    if (!variant) return;
    var formatted;
    try {
      formatted = JSON.parse(priceData.textContent)[String(variant.id)];
    } catch (error) {
      return;
    }
    if (!formatted) return;
    var price = priceBlock.querySelector('.price');
    if (!price) return;

    setText(price, '.price__regular .price-item--regular', formatted.price);
    setText(price, '.price__sale .price-item--sale', formatted.price);
    setText(price, '.price__compare-price .price-item--regular', formatted.compare);
    setText(price, '.badge__percentage-saved', formatted.percentage);
    setText(price, '.badge__money-saved', formatted.saving);

    price.classList.toggle('price--on-sale', formatted.on_sale === true);
    price.classList.toggle('price--sold-out', formatted.available === false);
    if (formatted.on_sale === true) price.classList.remove('price--no-compare');
    priceBlock.dataset.emVariantId = String(variant.id);
  }

  function watch(sectionId) {
    var priceBlock = document.getElementById('price-' + sectionId);
    if (!priceBlock || tracked.has(priceBlock)) return;
    tracked.add(priceBlock);
    new MutationObserver(function () { apply(sectionId); }).observe(priceBlock, {
      childList: true,
      subtree: true,
      characterData: true
    });
    apply(sectionId);
  }

  function schedule(sectionId) {
    if (!sectionId) return;
    if (pending[sectionId]) pending[sectionId].forEach(clearTimeout);
    pending[sectionId] = [0, 100, 350, 900].map(function (delay) {
      return setTimeout(function () {
        watch(sectionId);
        apply(sectionId);
      }, delay);
    });
  }

  function onVariantEvent(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var picker = target.closest('variant-selects[data-section]');
    if (picker) {
      schedule(picker.dataset.section);
      return;
    }
    var quantityRoot = target.closest('quantity-breaks[data-section]');
    if (quantityRoot &&
      (target.matches('.quantity-break__variant-select') || target.matches('input[name="quantity"]'))) {
      schedule(quantityRoot.dataset.section);
    }
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('variant-selects[data-section]'), function (picker) {
      watch(picker.dataset.section);
      schedule(picker.dataset.section);
    });
  }

  document.addEventListener('change', onVariantEvent, true);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
})();
